<template>
  <div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">AI Context Facts</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newFact()">New</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
    <div id="content">
		<div class="row">
			<div class="col-md-10"></div>
			<div class="col-md-2"><b-button @click="showSidebar=true" size="sm" pull-right><b-icon icon="search"/> Criteria</b-button><br/><br/></div>
		</div>
		<b-table v-if="criteria" :items="criteria" :fields="['factKey', 'description', 'actions']">
			<template #cell(actions)="data">
				<a @click="deleteFact(data.item.id)"><b-icon icon="trash"/></a> &nbsp;&nbsp;&nbsp;<a @click="editFact(data.item.id, data.item.factKey, data.item.description)"><b-icon icon="three-dots"/></a>
			</template>
		</b-table>
		<card v-if="showNew">
			<b-row>
				<b-col md="4">
					Fact Key: <b-form-input class="mb-2" v-model="fact.factKey"></b-form-input>
				</b-col>
				<b-col>
					Description: <b-form-input class="mb-2" v-model="fact.description"></b-form-input>
				</b-col>
				
			</b-row>
			<b-row>
				<b-col md="3">
					<b-button @click="saveNewFact">OK</b-button>
				</b-col>
			</b-row>
		</card>
		<b-sidebar id="sidebar" :visible="showSidebar" class="sidebar" title="" right shadow>
			<div class="px-4 py-2">
				<div id="criteria">
					<b-button :title="f.description" class="btn-sm" v-for="f in facts" :key="f.id" @click="fact.factKey = f.fact; fact.description = f.description; newFact();">{{f.fact}}</b-button>
				</div>
			</div>
		</b-sidebar>
	</div>
</div>
</template>
<script>
export default {
	name: "PSMs",
	data() {
		return {
			criteria: null,
			facts: null,
			search: "",
			showNew: false,
			fact: {factKey:"",description:""},
			showSidebar: false
		};
	},
	methods: {
		getCriteria: function () {
			this.$http.get(this.$config.ApiUri + "/WhiteListFact").then((result) => {
				this.criteria = result.data;
				for(var c = 0; c < this.criteria.length; c++){
					this.facts[c].actions = '';
				}
			});
		},
		getFacts: function () {
			this.$http.get(this.$config.ApiUri + "/Criteria").then((result) => {
				this.facts = result.data;
				this.facts.sort();
			});
		},
		newFact: function() {
			this.showNew = true;
		},
		saveNewFact: function() {
			this.$http.post(this.$config.ApiUri + "/WhiteListFact", this.fact).then(() => {
				this.fact.factKey = '';
				this.fact.description = '';
				this.showNew = false;
				this.getCriteria();
			});
		},
		deleteFact: function(id) {
			this.$http.delete(this.$config.ApiUri + "/WhiteListFact/" + id).then(() => {
				this.getCriteria();
			});
		},
		editFact: function(id, key, desc) {
			this.fact.factKey = key;
			this.fact.description = desc;
			this.$http.delete(this.$config.ApiUri + "/WhiteListFact/" + id).then(() => {
				this.showNew = true;
			});
		},
		onLoad() {
			this.getFacts();
			this.getCriteria();
		},
	},
	mounted: function () {
		this.onLoad();
	},
};
</script>
	
<style>
</style>